import { render, staticRenderFns } from "./SidebarTree.vue?vue&type=template&id=5ef19f99&"
import script from "./SidebarTree.vue?vue&type=script&lang=js&"
export * from "./SidebarTree.vue?vue&type=script&lang=js&"
import style0 from "./SidebarTree.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports